<template>
  <div v-if="company" class="card main-info">
    <div class="card-body">
      <h5 class="card-title">Основная информация</h5>

      <ul v-if="company.company_name_en" class="info-list">
        <li class="pt-3">
          <span class="info-title">Название (EN):</span>
          <span class="info-value">{{ company.company_name_en }}</span>
        </li>
        <li v-if="company.uscc" class="pt-3">
          <span class="info-title">USCC (Рег. номер):</span>
          <span class="info-value">{{ company.uscc }}</span>
        </li>
        <li class="pt-3">
          <span class="info-title">Отрасль:</span>
          <span class="info-value">{{ company.industry || 'Не указана' }}</span>
        </li>
        <li class="pt-3">
          <span class="info-title">Регион / Город:</span>
          <span class="info-value">{{ company.country_province_city }}</span>
        </li>
        <li v-if="company.year_founded_estimated" class="pt-3">
          <span class="info-title">Год основания:</span>
          <span class="info-value">{{ company.year_founded_estimated }}</span>
        </li>
        <li v-if="company.official_website" class="pt-3">
          <span class="info-title">Официальный сайт:</span>
          <span class="info-value">
            <a :href="company.official_website" target="_blank">{{ company.official_website }}</a>
          </span>
        </li>
        <li v-if="company.business_description" class="pt-4">
          <span class="info-title">Описание деятельности:</span>
          <span class="info-value" style="color: #555; line-height: 1.6">{{ company.business_description }}</span>
        </li>
      </ul>

      <ul v-else-if="company.fio && !company.name" class="info-list">
        <li class="pt-3">
          <span class="info-title">ФИО:</span>
          <span class="info-value">{{ company.fio }}</span>
        </li>
        <div class="d-flex pt-3">
          <li class="col-6">
            <span class="info-title">ИНН:</span>
            <span class="info-value" style="position: relative"
              >{{ company.inn }}
              <div v-if="showHint[0]" class="hint">{{ hint[0] }}</div>
              <img
                class="copy ms-2"
                src="@/assets/images/icons/copy.svg"
                @mouseover="showHint[0] = true"
                @mouseleave="showHint[0] = false"
                @click="copyText(company.inn, 0)"
            /></span>
          </li>
          <li class="col-6">
            <span class="info-title">ОГРНИП:</span>
            <span class="info-value" style="position: relative"
              >{{ company.ogrn }}
              <div v-if="showHint[1]" class="hint">{{ hint[1] }}</div>
              <img
                class="copy ms-2"
                src="@/assets/images/icons/copy.png"
                @mouseover="showHint[1] = true"
                @mouseleave="showHint[1] = false"
                @click="copyText(company.ogrn, 1)"
            /></span>
          </li>
        </div>
        <div class="d-flex pt-3">
          <li class="col-6">
            <span class="info-title">Дата регистрации:</span>
            <span class="info-value">{{ formatDate(company.registration_date) }}</span>
          </li>
          <li class="col-6">
            <span class="info-title">Тип:</span>
            <span class="info-value">{{ company.ip_type_full || company.ip_type || 'ИП' }}</span>
          </li>
        </div>
        <li class="pt-3">
          <span class="info-title">Статус:</span>
          <span class="info-value">{{ company.status?.name || 'Нет данных' }}</span>
        </li>
        <li class="pt-3">
          <span class="info-title">Город:</span>
          <span class="info-value">{{ company.city || 'Нет данных' }}</span>
        </li>
        <li class="pt-3">
          <span class="info-title">Основной вид деятельности:</span>
          <span class="info-value">{{ company.okved?.name || 'Нет данных' }}</span>
        </li>
        <li class="pt-3">
          <span class="info-title">Налоговый орган:</span>
          <span class="info-value">{{ company.taxAuthority?.name || 'Нет данных' }}</span>
        </li>
        <li class="py-3">
          <span class="info-title">Коды статистики:</span>
          <span class="info-value"
            >ОКПО <strong>{{ company.okpo?.code || company.okpo || '—' }}</strong> <br />ОКАТО
            <strong>{{ company.okato?.code || '—' }}</strong> <br />ОКТМО
            <strong>{{ company.oktmo?.code || '—' }}</strong> <br />ОКФС
            <strong>{{ company.okfs?.code || '—' }}</strong> <br />ОКОГУ
            <strong>{{ company.okogu?.code || '—' }}</strong> <br />ОКОПФ
            <strong>{{ company.okopf?.code || '—' }}</strong>
          </span>
        </li>
      </ul>

      <ul v-else class="info-list">
        <li class="pt-3">
          <span class="info-title">Основной вид деятельности:</span>
          <span class="info-value">{{ company.okved?.name }}</span>
        </li>
        <div class="d-flex pt-3">
          <li class="col-4">
            <span class="info-title">ИНН:</span>
            <span class="info-value" style="position: relative"
              >{{ company.inn }}
              <div v-if="showHint[0]" class="hint">{{ hint[0] }}</div>
              <img
                class="copy ms-2"
                src="@/assets/images/icons/copy.svg"
                @mouseover="showHint[0] = true"
                @mouseleave="showHint[0] = false"
                @click="copyText(company.inn, 0)"
            /></span>
          </li>
          <li v-if="company.kpp" class="col-4">
            <span class="info-title">КПП:</span>
            <span class="info-value">{{ company.kpp }}</span>
          </li>
          <li class="col-4">
            <span class="info-title">ОГРН:</span>
            <span class="info-value" style="position: relative"
              >{{ company.ogrn }}
              <div v-if="showHint[1]" class="hint">{{ hint[1] }}</div>
              <img
                class="copy ms-2"
                src="@/assets/images/icons/copy.png"
                @mouseover="showHint[1] = true"
                @mouseleave="showHint[1] = false"
                @click="copyText(company.ogrn, 1)"
            /></span>
          </li>
        </div>
        <div class="d-flex pt-3">
          <li class="col-6">
            <span class="info-title">Дата регистрации:</span>
            <span class="info-value">{{ formatDate(company.registration_date) }}</span>
          </li>
          <li v-if="company.share_capital" class="col-6">
            <span class="info-title">Уставный капитал:</span>
            <span class="info-value">{{ company.share_capital?.total }}</span>
          </li>
        </div>
        <li class="pt-3">
          <span class="info-title">Юридический адрес:</span>
          <span class="info-value">{{ company.legal_adress?.adress || company.city }} </span>
        </li>
        <li class="pt-3">
          <span class="info-title">Руководитель:</span>
          <span class="info-value">{{ company.directors?.length ? company.directors[0]?.fio : 'Неизвестно' }}</span>
        </li>
        <li class="pt-3">
          <span class="info-title">Среднесписочная численность:</span>
          <span class="info-value">нет данных</span>
        </li>
        <li class="pt-3">
          <span class="info-title">Специальный налоговый режим:</span>
          <span class="info-value">Не применяется</span>
        </li>
        <div class="d-flex pt-3">
          <li class="col-6">
            <span class="info-title">Реестр МСП:</span>
            <span class="info-value">Не применяется</span>
          </li>
          <li class="col-6">
            <span class="info-title">Место в отрасли:</span>
            <span class="info-value">Не применяется по выручке</span>
          </li>
        </div>
        <li class="pt-3">
          <span class="info-title">Налоговый орган:</span>
          <span class="info-value">{{ company.taxAuthority?.name }} </span>
        </li>
        <li class="py-3">
          <span class="info-title">Коды статистики:</span>
          <span class="info-value"
            >ОКПО <strong>{{ company.okpo?.code || company.okpo }}</strong> <br />ОКАТО
            <strong>{{ company.okato?.code }}</strong> <br />ОКТМО <strong>{{ company.oktmo?.code }}</strong> <br />ОКФС
            <strong>{{ company.okfs?.code }}</strong> <br /><strong>{{ company.okfs?.name }}</strong> <br />ОКОГУ
            <strong>{{ company.okogu?.code }}</strong> <br />{{ company.okogu?.name }} <br />ОКОПФ
            <strong>{{ company.okopf?.code }}</strong>
          </span>
        </li>
        <div class="divider"></div>
        <div class="divider"></div>
        <li class="pt-3">
          <span class="info-value"
            >Председатель правления {{ company.name || company.fio }} -
            {{ company.directors?.length ? company.directors[0]?.fio : company.fio }}
            (ИНН
            {{ company.directors?.length ? company.directors[0].inn : company.inn }}). Организации присвоен ИНН
            {{ company.inn }}, ОГРН {{ company.ogrn }}</span
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import company from '@/services/company';
  import { defineComponent, ref } from 'vue';
  import { useStore } from 'vuex';
  import moment from 'moment';

  export default defineComponent({
    name: 'MainInfo',
    props: {
      company: Object,
    },
    setup(props) {
      const store = useStore();
      const showHint = ref([false, false]);
      const hint = ref(['Скопировать', 'Скопировать']);
      const copyText = (textToCopy, index) => {
        navigator.clipboard
          .writeText(textToCopy)
          .then(() => {
            hint.value[index] = 'Скопировано!';
            setTimeout(() => {
              hint.value[index] = 'Скопировать';
            }, 2000);
          })
          .catch((err) => {
            console.error('Ошибка копирования текста: ', err);
          });
      };

      const formatDate = (date) => {
        return moment(date).format('DD.MM.YYYY');
      };

      return {
        showHint,
        hint,
        copyText,
        formatDate,
      };
    },
  });
</script>

<style scoped lang="scss">
  @media (max-width: 768px) {
    .main-info {
      .d-flex {
        flex-direction: column !important;
        gap: 0.75rem;
      }

      .col-4,
      .col-6 {
        width: 100%;
      }

      .info-list li {
        font-size: 14px;
      }

      .info-value {
        word-break: break-word;
      }
    }
  }
</style>
